import {
  setUnreadNotification,
  updateNotificationStatus,
} from "./notificationSlice";
import * as notificationsService from "../../../services/Notifications";

export const fetchNotifications = (stakeholderId) => async (dispatch) => {
  try {
    const notifications = await notificationsService.getNotificationsByStakeholderId(
      stakeholderId,
      true
    );

    console.log('notifications', notifications)

    dispatch(setUnreadNotification(notifications.data));
  } catch (err) {
    throw err;
  }
};

export const changeNotificationStatus = (id) => async (dispatch) => {
  try {
    let res = await notificationsService.changeNotificationStatus(id);

    dispatch(updateNotificationStatus({ id, count: res?.data?.unreadCount }));
    return res;
  } catch (err) {
    throw err;
  }
};
